export const DEFAULT_TRANSLATES: ITranslates = {
  title: 't.lootbox-default-title',
};

interface ITranslates {
  title: string;
}

interface ITranslatesObject {
  [key: string]: ITranslates;
}

export interface ILootboxesTranslatesCMS {
  FieldModifyTranslations: string;
  Translates: ITranslatesObject;
}
